module.exports = __webpack_public_path__ + "img/monocycle-parked-moved.66739f3e.jpg";